'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HighlightsIcon = function HighlightsIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M25.1309524,17.0427927 L19.2465728,16.1871061 L16.618549,10.8571429 L13.9915225,16.1871061 L8.10714286,17.0427927 L12.3648406,21.1966891 L11.361504,27.0589456 L16.618549,24.2910205 L21.8765912,27.0579413 L20.8732546,21.1966891 L25.1309524,17.0427927 L25.1309524,17.0427927 Z M24.2797619,4 C25.2828995,7.27556176 28.5357143,8.28571428 28.5357143,8.28571428 C28.5357143,8.28571428 25.2828996,9.29586689 24.2797619,12.5714286 C23.2766243,9.29586689 20.0238095,8.28571428 20.0238095,8.28571428 C20.0238095,8.28571428 23.3610393,7.19055642 24.2797619,4 L24.2797619,4 Z M5.55357143,22.8571428 C6.15545398,24.8224799 8.10714286,25.4285714 8.10714286,25.4285714 C8.10714286,25.4285714 6.15545403,26.034663 5.55357143,28 C4.95168883,26.034663 3,25.4285714 3,25.4285714 C3,25.4285714 5.0023379,24.7714767 5.55357143,22.8571428 L5.55357143,22.8571428 Z' })
  );
};

HighlightsIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = HighlightsIcon;